import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  chipFinished: {
    borderColor: '#4caf50',
    color: '#4caf50',
    fontWeight: 'bold',
    fontSize: '0.7rem',
  },
  chipLeft: {
    borderColor: '#ff9800',
    color: '#ff9800',
    fontWeight: 'bold',
    fontSize: '0.7rem',
  },
  chipNotStarted: {
    borderColor: theme.palette.text.secondary,
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    fontSize: '0.7rem',
  },
}));

export function StatusChip({ status }) {
  const classes = useStyles();
  switch (status) {
    case 'finished':
      return <Chip label="CONCLUÍDO" variant="outlined" className={classes.chipFinished} size="small" />;
    case 'started':
      return <Chip label="FINALIZADA AUTOMATICAMENTE" variant="outlined" className={classes.chipLeft} size="small" />;
    default:
      return <Chip label="NÃO INICIADO" variant="outlined" className={classes.chipNotStarted} size="small" />;
  }
}

export function StatusPrintedChip({ status }) {
  const classes = useStyles();
  switch (status) {
    case 'finished':
      return <Chip label="CONCLUÍDO" variant="outlined" className={classes.chipFinished} size="small" />;
    default:
      return <Chip label="AGUARDANDO RESULTADOS" variant="outlined" className={classes.chipNotStarted} size="small" />;
  }
}
